import { useEffect, useRef } from 'react';

import { useAppSelector } from 'store/store-hooks';
import { FinalcutsListElement } from './finalcuts-list-element';
import { FinalcutMenuContainer } from './finalcuts-list-element-menu';

import styles from './_finalcuts-list.module.scss';

export const FinalcutsList = () => {
  const finalcuts = useAppSelector((state) => state.app__data.finalcuts);
  const tracksRestored = useAppSelector((state) => state.memory.tracksRestored);
  const selectedFinalcut = useAppSelector((state) => state.projects.selectedFinalcut);
  const { fcProgress, fcQueue } = useAppSelector((state) => state.fc__renderServer);

  const isScrolled = useRef(false);
  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!tracksRestored || !finalcuts.length || isScrolled.current) return;
    const i = finalcuts.findIndex((el) => el.id === selectedFinalcut);
    const el = container.current!.children[i] as HTMLDivElement;
    container.current!.parentElement!.scrollTop = el?.offsetTop - container.current!.offsetTop;
    isScrolled.current = true;
  }, [finalcuts, tracksRestored]);

  return (
    <div ref={container} className={styles.FcList}>
      {finalcuts.length > 0 &&
        finalcuts.map((el) => (
          <FinalcutMenuContainer key={el.id} finalcut={el}>
            <FinalcutsListElement element={el} progress={fcProgress[el.id]} positionInQueue={fcQueue[el.id]} />
          </FinalcutMenuContainer>
        ))}
    </div>
  );
};
